import { getToken } from '.'

const justFormDataUrl = [
  'crm/ex/v1/tanya-saham/portofolio/add',
  'crm/ex/v1/tanya-saham/portofolio/update',
  'crm/ex/v1/tanya-saham/lainnya',
  'crm/ex/v1/tanya-saham/reply',
]

function checkIsJustFormData(url, method) {
  const result = justFormDataUrl.filter(item => url.includes(item))
  return result?.length > 0 && ['post', 'put'].includes(method)
}

export function getHeader(params) {
  const { method, url } = params

  /** 👇 HEADER FORM DATA */
  const isJustFormData = checkIsJustFormData(url, method)
  if (isJustFormData) {
    return {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + getToken()
    }
  }

  /** 👇 HEADER APPLICATION JSON */
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + getToken()
  }
}

export const removeBrokenPayload = (payload) => {
  if (typeof payload !== 'object') return paylaod

  const payloadArr = Object.entries(payload)
  if (!payloadArr?.length) return null
  const result = payloadArr.reduce((acc, curr) => {
    const [key, value] = curr
    const enablePayload = (typeof value === 'string' && value?.length) || (typeof value === 'number' && value >= 0)
    return {
      ...acc,
      ...(enablePayload && { [key]: value })
    }
  }, {})

  return result
}
